export const parseAnoMes = (anoMes: string): Date => {
  const [monthStr, year] = anoMes.split("-");
  const monthMap: { [key: string]: number } = {
    jan: 0,
    fev: 1,
    mar: 2,
    abr: 3,
    mai: 4,
    jun: 5,
    jul: 6,
    ago: 7,
    set: 8,
    out: 9,
    nov: 10,
    dez: 11,
  };
  const month = monthMap[monthStr.toLowerCase()];
  if (month === undefined) {
    throw new Error(`mês inválido: ${monthStr}`);
  }
  return new Date(Number(year), month, 1);
};
